const reloadThumbnailEmbeds = () => {
    const iframes = document.querySelectorAll('.post-card-thumbnail-embed-code-wrapper iframe.ceros-experience');

    iframes.forEach(iframe => {
        const currentSrc = iframe.src;
        iframe.src = ''; // Set the src to empty to force a reload
        iframe.src = currentSrc; // Restore the original src
    });
};

if (document.readyState !== 'loading') {
    reloadThumbnailEmbeds();
} else {
    window.addEventListener('DOMContentLoaded', (event) => {
        reloadThumbnailEmbeds()
    });
}